module.exports = __webpack_public_path__ + "img/Carson.90818648.png";